import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { SortableContainer, SortableElement } from "react-sortable-hoc";

import {
  Breadcrumb,
  Button,
  Divider,
  Icon,
  Input,
  message,
  Popconfirm,
  Radio,
  Row,
  Select,
  Switch,
} from "antd";
import {
  QuestionPanel,
  QuestionHeader,
  QuestionMain,
  QuestionFooter,
  QuestionInput,
  NPSOptions,
  RadioOptions,
  RadioOption,
  HighlightActiveQuestion,
  AddQuestionBtn,
} from "./formStyledComponents";
import Text from "antd/lib/typography/Text";
import Loader from "components/Loader/Loader";
import { deleteQuestionArchive } from "utils/apiService";

const { Option } = Select;
const { TextArea } = Input;

const UUID = () => {
  var self = {};
  var lut = [];
  for (var i = 0; i < 256; i++) {
    lut[i] = (i < 16 ? "0" : "") + i.toString(16);
  }
  self.generate = function () {
    var d0 = (Math.random() * 0xffffffff) | 0;
    var d1 = (Math.random() * 0xffffffff) | 0;
    var d2 = (Math.random() * 0xffffffff) | 0;
    var d3 = (Math.random() * 0xffffffff) | 0;
    return (
      lut[d0 & 0xff] +
      lut[(d0 >> 8) & 0xff] +
      lut[(d0 >> 16) & 0xff] +
      lut[(d0 >> 24) & 0xff] +
      "-" +
      lut[d1 & 0xff] +
      lut[(d1 >> 8) & 0xff] +
      "-" +
      lut[((d1 >> 16) & 0x0f) | 0x40] +
      lut[(d1 >> 24) & 0xff] +
      "-" +
      lut[(d2 & 0x3f) | 0x80] +
      lut[(d2 >> 8) & 0xff] +
      "-" +
      lut[(d2 >> 16) & 0xff] +
      lut[(d2 >> 24) & 0xff] +
      lut[d3 & 0xff] +
      lut[(d3 >> 8) & 0xff] +
      lut[(d3 >> 16) & 0xff] +
      lut[(d3 >> 24) & 0xff]
    );
  };
  return self;
};

const SortableItem = SortableElement(
  ({
    item,
    activeIndex,
    setActiveIndex,
    handleQuestionChange,
    handleQuestionType,
    questionIndex,
    toggleRequired,
    deleteQuestion,
    handleOptionChange,
    addNewOption,
    deleteOption,
    create,
    ...rest
  }) => {
    return (
      <QuestionPanel
        {...rest}
        key={item.uuid}
        onClick={() => {
          setActiveIndex(questionIndex);
        }}
      >
        <QuestionHeader>
          <QuestionInput>
            <Icon type="menu" />
            <Input
              placeholder="Enter your question here..."
              style={{ marginLeft: "12px", border: "1px solid #D9D9D9" }}
              value={item.title}
              disabled={!create && !item.new_question ? true : false}
              onChange={(e) =>
                handleQuestionChange(e.target.value, questionIndex)
              }
            />
          </QuestionInput>
          <Select
            disabled={!create && !item.new_question ? true : false}
            showSearch
            style={{
              width: "330px",
              border: "1px solid #D9D9D9",
              borderRadius: "5px",
              padding: "3px 0",
              background: "white important",
            }}
            placeholder="Select a question type"
            // defaultValue={"nps"}
            value={item.type === "" ? null : item.type}
            optionFilterProp="children"
            onChange={(value) => handleQuestionType(value, questionIndex)}
            // onFocus={onFocus} onBlur={onBlur} onSearch={onSearch} filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
          >
            <Option value="nps">
              <Icon type="number" style={{ marginRight: "10px" }} />
              NPS Score 1-10
            </Option>
            <Option value="mcq">
              <Icon type="check-circle" style={{ marginRight: "10px" }} />
              Multiple Choice Questions
            </Option>
            <Option value="paragraph">
              <Icon type="align-left" style={{ marginRight: "10px" }} />
              Paragraph
            </Option>
          </Select>
        </QuestionHeader>
        <QuestionMain>
          {item.type === "nps" ? (
            <NPSOptions>
              <Radio.Group
                disabled
                style={{ display: "flex", flexDirection: "column" }}
              >
                <div className="scale-title">
                  <span>Very Unlikely</span> <span>Likely</span>
                </div>
                <div style={{ display: "flex" }}>
                  {[...Array(10).keys()].map((value, index) => (
                    <Radio.Button key={index} value={value + 1}>
                      {value + 1}
                    </Radio.Button>
                  ))}
                </div>
              </Radio.Group>
            </NPSOptions>
          ) : item.type === "mcq" ? (
            <RadioOptions>
              {item.options.map((option, optionIndex) => (
                <RadioOption key={optionIndex}>
                  <Icon type="minus-circle" style={{ color: "#D9D9D9" }} />
                  <Input
                    placeholder="Enter option here..."
                    style={{
                      marginLeft: "12px",
                      border: "1px solid #D9D9D9",
                      maxWidth: 400,
                    }}
                    value={option}
                    onChange={(e) => {
                      handleOptionChange(
                        e.target.value,
                        optionIndex,
                        questionIndex
                      );
                    }}
                  />
                  <button
                    onClick={() => {
                      deleteOption(optionIndex, questionIndex);
                    }}
                  >
                    <Icon type="close" />
                  </button>
                </RadioOption>
              ))}
            </RadioOptions>
          ) : (
            <TextArea
              placeholder="User can enter his answer here."
              rows={4}
              disabled
              autoSize={{ minRows: 4, maxRows: 6 }}
            />
          )}
        </QuestionMain>
        <QuestionFooter>
          <div>
            <Switch
              checked={item.is_required}
              onChange={(checked) => toggleRequired(checked, questionIndex)}
            />{" "}
            <Text
              style={{
                /*fontFamily: "Gotham",*/ fontStyle: "normal",
                fontWeight: "normal",
                fontSize: "14px",
                lineHeight: "22px",
                color: "#181818",
              }}
            >
              Required
            </Text>
            <Divider type="vertical" style={{ margin: "0 12px", height: 24 }} />
            <Popconfirm
              placement="topRight"
              title={"Are you sure?"}
              icon={<Icon type="question-circle-o" style={{ color: "red" }} />}
              onConfirm={() => {
                deleteQuestion(questionIndex);
                // debugger;+--+
              }}
              okText="Yes"
              cancelText="No"
            >
              <button>
                <Icon type="delete" />
              </button>
            </Popconfirm>
          </div>
          {item.type === "mcq" && (
            <button
              onClick={() => {
                addNewOption(questionIndex);
              }}
            >
              <Icon type="plus" />
              Add More Option
            </button>
          )}
        </QuestionFooter>
        {questionIndex === activeIndex && <HighlightActiveQuestion />}
      </QuestionPanel>
    );
  }
);

const SortableList = SortableContainer(({ items, addNewQuestion, ...rest }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <Row style={{ width: "100%", backgroundColor: "transparent" }}>
      {items.map((item, index) => (
        <SortableItem
          key={item.uuid}
          index={index}
          questionIndex={index}
          activeIndex={activeIndex}
          setActiveIndex={setActiveIndex}
          item={item}
          {...rest}
        />
      ))}
      <QuestionPanel onClick={addNewQuestion}>
        <AddQuestionBtn>
          <Icon type="plus" />
          Add More Question
        </AddQuestionBtn>
      </QuestionPanel>
    </Row>
  );
});

const FormBuilder = (props) => {
  const { formID } = useParams();

  const [loading, setLoading] = useState(true);
  const [questionList, setQuestionList] = useState({
    title: "Untitled Survey",
    survey_questions: [
      {
        title: "",
        type: "nps",
        options: [],
        is_required: false,
        uuid: UUID().generate(),
      },
    ],
  });

  Array.prototype.move = function (from, to) {
    this.splice(to, 0, this.splice(from, 1)[0]);
  };

  const handleQuestionSort = (object) => {
    if (object.newIndex !== object.oldIndex) {
      let questionList_copy = [...questionList.survey_questions];
      questionList_copy.move(object.oldIndex, object.newIndex);
      setQuestionList({ ...questionList, survey_questions: questionList_copy });
    }
  };

  const handleQuestionChange = (title, index) => {
    let questionList_copy = [...questionList.survey_questions];
    questionList_copy[index].title = title;
    setQuestionList({ ...questionList, survey_questions: questionList_copy });
  };

  const handleQuestionType = (type, index) => {
    let questionList_copy = [...questionList.survey_questions];
    questionList_copy[index].type = type;
    setQuestionList({ ...questionList, survey_questions: questionList_copy });
  };

  const addNewQuestion = () => {
    let questionList_copy = [...questionList.survey_questions];
    let tempQuestion = {
      title: "",
      type: "nps",
      is_required: false,
      options: [],
      uuid: UUID().generate(),
      new_question: true,
    };
    questionList_copy.push(tempQuestion);
    setQuestionList({ ...questionList, survey_questions: questionList_copy });
  };

  const toggleRequired = (checked, index) => {
    let questionList_copy = [...questionList.survey_questions];
    questionList_copy[index].is_required = checked;
    setQuestionList({ ...questionList, survey_questions: questionList_copy });
  };

  const deleteQuestion = (index) => {
    let questionList_copy = [...questionList.survey_questions];
    deleteQuestionArchive({requestData: {uuid:questionList_copy[index].uuid},
      resCallback: () => {},
      res200Callback: (res) => {message.success("Question deleted")}});
    questionList_copy.splice(index, 1);
    setQuestionList({ ...questionList, survey_questions: questionList_copy });
  };

  const handleOptionChange = (optionValue, optionIndex, index) => {
    let questionList_copy = [...questionList.survey_questions];
    questionList_copy[index].options[optionIndex] = optionValue;
    setQuestionList({ ...questionList, survey_questions: questionList_copy });
  };

  const addNewOption = (index) => {
    let questionList_copy = [...questionList.survey_questions];
    let tempOption = "";
    questionList_copy[index].options.push(tempOption);
    setQuestionList({ ...questionList, survey_questions: questionList_copy });
  };

  const deleteOption = (optionIndex, index) => {
    let questionList_copy = [...questionList.survey_questions];
    questionList_copy[index].options.splice(optionIndex, 1);
    setQuestionList({ ...questionList, survey_questions: questionList_copy });
  };

  const saveForm = () => {
    props.handleSaveAPI({
      requestData: {
        ...questionList,
      },
      res200Callback: (res) => {
        message.success("Form saved successfully");
        res.data.uuid &&
          setQuestionList({ ...questionList, uuid: res.data.uuid });
      },
      resErrorCallback: () => {
        message.error("Something went wrong while saving form!");
      },
    });
  };

  useEffect(() => {
    !props.create &&
      props.fetchSurveyDetails({
        requestData: {
          uuid: formID,
        },
        resCallback: () => {
          loading && setLoading(false);
        },
        res200Callback: (res) => {
          setQuestionList({ ...res.data });
        },
        resErrorCallback: () => {
          props.history.go(-1);
        },
      });
  }, []);

  return loading && !props.create ? (
    <Row
      type="flex"
      align="middle"
      justify="center"
      style={{ marginTop: "200px" }}
    >
      <Loader />
    </Row>
  ) : (
    <>
      <Row type="flex" justify="space-between" align="top">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: 8,
            width: "310px",
          }}
        >
          <Input
            style={{
              width: "265px",
              color: "#181818",
              fontStyle: "normal",
              fontWeight: "bold",
              fontSize: "24px",
              lineHeight: "39px",
              padding: "8px 10px",
            }}
            className="form_title"
            value={questionList.title}
            onChange={(e) =>
              setQuestionList({ ...questionList, title: `${e.target.value}` })
            }
            placeholder="Enter the Survey Title"
            bordered="false"
          />
          <Icon type="edit" style={{ fontSize: "18px", color: "#A3A3A3" }} />
        </div>
        <Button
          onClick={saveForm}
          style={{
            display: "flex",
            alignItems: "center",
            padding: "8px 16px",
            color: "#FFFFFF",
            fontSize: "16px",
            lineHeight: "24px",
            background: "#fec708",
            borderRadius: "5px",
            height: "100%",
            margin: "0 0 0 12px",
          }}
        >
          <Icon
            type="cloud-upload"
            style={{
              height: "16px",
            }}
          />
          Save Form
        </Button>
      </Row>
      <Breadcrumb
        style={{ marginBottom: 12 }}
        separator={<span style={{ color: "#747474" }}>{"<"}</span>}
      >
        <Breadcrumb.Item
          style={{
            /*fontFamily: "Gotham",*/ fontStyle: "normal",
            fontWeight: "normal",
            fontSize: "14px",
            lineHeight: "22px",
            color: "#747474",
          }}
        >
          <Link to={"/app-feedback"}>Survey</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item
          style={{
            /*fontFamily: "Gotham",*/ fontStyle: "normal",
            fontWeight: "normal",
            fontSize: "14px",
            lineHeight: "22px",
            color: "#464646",
          }}
        >
          {props.create ? "Create Survey Form" : "Edit Survey Form"}
        </Breadcrumb.Item>
      </Breadcrumb>
      <SortableList
        items={questionList.survey_questions}
        onSortEnd={handleQuestionSort}
        handleQuestionChange={handleQuestionChange}
        handleQuestionType={handleQuestionType}
        addNewQuestion={addNewQuestion}
        toggleRequired={toggleRequired}
        deleteQuestion={deleteQuestion}
        handleOptionChange={handleOptionChange}
        addNewOption={addNewOption}
        deleteOption={deleteOption}
        create={props.create}
      />
    </>
  );
};

export default FormBuilder;
